export const projectCards = [
  {
    id: 7,
    cardName: "Milwaukee Brewers Homerun App",
    techStack: "Fullstack",
    imageUrl: `${process.env.PUBLIC_URL}/images/mkeHomeRunApp.webp`,
    released: false,
    releaseDate: "Demo",
    siteUrl: "https://homerun-hub.com/",
    description:
      "I built the Milwaukee Brewers Home Run App in one week as part of their Software Development Intern interview process, demonstrating my skills in ReactJS, TailwindCSS, ShadCN, NodeJS, and ExpressJS. The app uses versioned APIs for efficient caching and filtering, allowing quick searches across all 30 MLB teams using data provided by the Brewers' API. My performance on this project led to my selection as the only Software Development Intern for the Milwaukee Brewers in 2024.",
    techUsed: ["ReactJs", "TailwindCss", "ShadCN", "Nodejs", "ExpressJs"],
    filters: [
      "javascript",
      "typescript",
      "fullstack",
      "html",
      "css",
      "express",
      "nodejs",
    ],
  },
  {
    id: 0,
    cardName: "Better Stewards",
    techStack: "FrontEnd",
    imageUrl: `${process.env.PUBLIC_URL}/images/better-steward2.avif`,
    released: true,
    releaseDate: "02/17/2024",
    siteUrl: "https://betterstewards.org/",
    description:
      "I've developed a WordPress website aimed at enhancing the promotion efforts of the Better Stewards non-profit organization. This platform serves as a comprehensive online presence, showcasing the organization's mission, initiatives, and impact. Through intuitive design and engaging content, the website aims to amplify awareness and support for Better Stewards' important work within the community.",
    techUsed: ["Wordpress", "JavaScript", "MySQL", "CPanel"],
    filters: ["wordpress", "javascript", "frontend", "mysql"],
  },
  {
    id: 8,
    cardName: "Pokemon Info Twitch Bot",
    techStack: "Fullstack",
    imageUrl: `${process.env.PUBLIC_URL}/images/PokemonInfoBotLogo.png`,
    released: true,
    releaseDate: "01/01/2024",
    siteUrl: "",
    description: `I developed a Twitch-integrated Pokémon Info Community Game Bot using NodeJS. The bot manages Twitch API connections for secure login, handles token storage, and integrates OpenAI's API to assist users with Pokémon information retrieval and team-building advice. It also connects to a locally hosted API through tunnels, enabling users to generate and post custom images directly to Imgur. The bot tracks Pokémon spawns, uses predictive analytics to forecast spawn types, and offers interactive chat games such as Tic-Tac-Toe and Pokémon Hangman. Currently, I'm also developing a companion website to showcase recent spawns and user-generated content.`,
    techUsed: ["NodeJs", "TypeScript", "Websockets", "ExpressJs"],
    filters: [
      "typescript",
      "javascript",
      "fullstack",
      "websockets",
      "express",
      "released",
      "nodejs",
    ],
  },
  {
    id: 1,
    cardName: "Auto-Catcher Bot (Pokemon community game)",
    techStack: "Desktop",
    imageUrl: `${process.env.PUBLIC_URL}/images/twitch-bot2.avif`,
    released: true,
    releaseDate: "12/20/2023",
    siteUrl: "",
    description: `I've developed an interactive desktop application using Node.js and tmi.js to seamlessly integrate with Twitch.tv via a real-time WebSocket connection. This innovative Twitch Bot is specifically designed for the Pokémon Community Game, automatically detecting Pokémon spawns, responding to special events, and simulating user actions such as throwing Pokéballs and managing Pokédex entries. By automating these interactions, the application enhances user experience, allowing effortless participation in Twitch-based gaming communities. Building this app required proficiency in JavaScript, WebSocket communications, event-driven programming, and API integration. This app currently has several users that use it daily.`,
    techUsed: ["NodeJs", "TypeScript", "Websockets"],
    filters: ["typescript", "javascript", "frontend", "released", "nodejs"],
  },
  {
    id: 3,
    cardName: "Gees Clippers",
    techStack: "Fullstack",
    imageUrl: `${process.env.PUBLIC_URL}/images/gee.png`,
    released: false,
    releaseDate: "N/A",
    siteUrl: "https://github.com/0112Derrick/GeesClippersTechTitans-Personal",
    description:
      "I worked on a project during my time with i.c.stars that revitalized a barbershop's corporate website. This involved integrating videos and implementing a content management system, enabling barbers to upload haircut photos and administrators to post real-time events. Additionally, the system included a review feature, facilitating communication between the barbershop and its community.",
    techUsed: ["HTML5", "CSS3", "TypeScript", "NodeJs", "ExpressJS"],
    filters: [
      "javascript",
      "typescript",
      "fullstack",
      "html",
      "css",
      "express",
      "nodejs",
    ],
  },
  {
    id: 4,
    cardName: "Wizards Dream",
    techStack: "Fullstack",
    imageUrl: `${process.env.PUBLIC_URL}/images/castle.webp`,
    released: false,
    releaseDate: "N/A: In Development",
    siteUrl: "https://github.com/0112Derrick/Wizards-Dream",
    description:
      "Since childhood, I've been captivated by MORPGs and online role-playing games. The communal bond they foster is what truly draws me in. Hence, I've embarked on a journey to create my own video game from the ground up, complete with its own game engine. This project will delve into the realms of magic and exploration, offering players a rich and immersive experience.",
    techUsed: [
      "HTML5",
      "CSS3",
      "TypeScript",
      "NodeJs",
      "ExpressJS",
      "Socket.IO",
    ],
    filters: [
      "javascript",
      "typescript",
      "fullstack",
      "html",
      "css",
      "express",
      "nodejs",
    ],
  },
  /*  {
    id: 5,
    cardName: "BIPOC",
    techStack: "Fullstack",
    imageUrl: `${process.env.PUBLIC_URL}/images/bipoc.jpeg`,
    released: false,
    releaseDate: "Paused",
    siteUrl: "https://github.com/0112Derrick/BIPOC_TS",
    description:
      "This app is designed to bridge the gap between employers and prospective employees within the green sector. It offers a dedicated space for both parties to discover and post open positions, fostering success and growth. Additionally, the app includes features such as affinity groups, providing a supportive environment for individuals in the BIPOC/LGBTQ+ community to connect with safe spaces and opportunities tailored to their needs.",
    techUsed: ["HTML5", "CSS3", "TypeScript"],
    filters: [
      "javascript",
      "typescript",
      "fullstack",
      "html",
      "css",
      "express",
      "nodejs",
    ],
  },
  {
    id: 2,
    cardName: "Laundromat Express",
    techStack: "Fullstack",
    imageUrl: `${process.env.PUBLIC_URL}/images/washer2.jpeg`,
    released: false,
    releaseDate: "N/A: In Development",
    siteUrl: "https://github.com/0112Derrick/Laundromat-Hub",
    description:
      "I have a vision for revolutionizing the way people pay for laundry services. I am developing an app that will enable users to pay for washing machine usage using their debit or credit cards directly from their smartphones, eliminating the need for searching for quarters. This innovation promises benefits for both customers and Laundromat owners, providing real-time visibility into machine usage for better management and convenience.",
    techUsed: ["ReactJS", "Asp.Net", "Bootstrap"],
    filters: [
      "react",
      "asp.net",
      "javascript",
      "typescript",
      "fullstack",
      "bootstrap",
    ],
  }, */
];
